import axios from "../general/HttpClient";

export function ListManagedServices(organizationId) {
    return axios.get(`/api/managedServices/ListManagedServices/${organizationId}`);
}

export function CreateManagedService(organizationId, managedService) {
    return axios.post(`/api/managedServices/CreateManagedService/${organizationId}`, managedService);
}

export function UpdateManagedService(organizationId, managedService) {
    return axios.put(`/api/managedServices/UpdateManagedService/${organizationId}`, managedService);
}

export function DeleteManagedService(organizationId, managedServiceId) {
    return axios.delete(`/api/managedServices/DeleteManagedService/${organizationId}`, { params: { managedServiceId } });
}

export function TypeName(type) {
    switch (type) {
        case 0:
            return "Link";
        case 1:
            return "SASAMS";
        case 2:
            return "Scadsys";
        case 3:
            return "Store";
        case 4:
            return "Scadsys Biometrics";
        case 5:
            return "Azure";
        case 6:
            return "COVID Screening";
        case 7:
            return "SendGrid";
        case 8:
            return "Discord";
    }
    return "Unknown";
}
